import { Injectable } from '@angular/core';
import { AllocationViewFixedTimelineModel, AllocationViewMode } from './constants';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewService {
  private readonly viewModeStorageKey = 'allocation-view-mode';
  private readonly viewFixTimelineKey = 'allocation-fix-timeline';

  getSavedViewMode(): AllocationViewMode {
    return localStorage.getItem(this.viewModeStorageKey) as AllocationViewMode;
  }

  getFixedTimelineFromStorage(): AllocationViewFixedTimelineModel {
    const timelineStorage = localStorage.getItem(this.viewFixTimelineKey);
    const timelineObj = JSON.parse(timelineStorage);

    return timelineObj || {};
  }

  saveViewMode(viewMode: AllocationViewMode): void {
    localStorage.setItem(this.viewModeStorageKey, viewMode);
  }

  saveFixedTimelineToStorage(value: AllocationViewFixedTimelineModel): void {
    localStorage.setItem(this.viewFixTimelineKey, JSON.stringify(value));
  }
}
